// Notification calls — Android MainActivity reads the unread count from pro/dashboard/init
// (notifications/unread only counts when a `_token` body param is present). Never throws.
import { apiCall } from "./apiCall";

export const notificationApi = {
  // background badge refresh: silent so the global loader doesn't flash
  unreadCount: () => apiCall("post", "dashboard/init", { platform: "web", type: "technician" }, { silent: true }),
};
